module.exports = __webpack_public_path__ + "images/ds-signup-bg-v2-mobile.webp";